<template>
  <div>
    <form @submit.prevent="validarCamposCuo" class="xcar" style="margin-top:0;" novalidate>
      <div class="row">
        <div class="col-sm-12">
          <b>Crear Nuevo Modulo:</b>
          <p>  <b>NOTA:</b> Utilice esta funcion solo cuando no haya encontrado el modulo que busca (Evite duplicar modulos), luego de crearlo puede buscarlo en la casilla de arriba </p>
          <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('modulo.nombre')}">
            <input type="text" v-model.trim="modulo.nombre" class="form-control" placeholder="Nombre del modulo" />
            <small> <span class="text-danger">*</span> Nombre del nuevo modulo.</small>
            <div class="error" v-if="validation.hasError('modulo.nombre')"> {{validation.firstError('modulo.nombre')}} </div>
          </div>

          <Alertas ref="alertarmod" />
          <button class="btn btn-sm btn-azul" @click="validarCamposCuo"> Registrar modulo </button>
        </div>
      </div>
      
      <p class="text-center">{{msg}}</p>
      <!-- <notifications group="auth3" position="bottom right" /> -->
    </form>
  </div>
</template>

<script>
import { Validator } from 'simple-vue-validator'
import Alertas from '@/components/AAlertas.vue'
import {parseJsonError,exito} from '@/components/Utils.js'
import gql from 'graphql-tag'

export default {
  props:{},
  data() {
    return {
      msg: '',
      activo: true,
      modulo:{
        nombre: null,
        sigla: "MOD",
        tipo: "NEW"
      }
    };
  },
  components:{Alertas},
  watch:{
    'modulo.nombre': function(){
      this.$refs.alertarmod.reset();
    },
  },
  validators: {
    'modulo.nombre'(value){ return Validator.value(value).minLength(5).required(); },
  },
  methods:{
    validarCamposCuo(){ 
      if( !this.activo ) return;
      this.activo = false;
      this.$validate().then((success) => {
        var obj = window.Object.assign({},this.modulo);
        if( success ){
          this.$store.state.obj = obj;
          this.$store.dispatch('quitarNulos');
          this.$refs.alertarmod.cargando();
          this.enviarDatos( obj )
        }else{
          this.$refs.alertarmod.invalido();
          this.activo = true;
        }
      });
    },
    enviarDatos( obj ) {
      var vue = this;
      var sql = gql`mutation{ createModulo(input:${window.stringifyObject(obj)}){ok,errors{message}} }`;
      vue.msg = "";
      // window.console.log(sql);

      this.$apollo.mutate({
        mutation: sql
        }).then(data => {
          if (data.data.createModulo.ok) {
            vue.$refs.alertarmod.success( "Modulo registrado, use el cuadro de arriba para buscarlo." );
            this.$notify( exito( "Exito","Modulo registrado, use el cuadro de arriba para buscarlo." ) )
            window.$('#collapseExamplem').collapse('hide');
            this.activo = true;
          } else {
            var errores = JSON.stringify(data.data.createModulo.errors);
            var obj = JSON.parse(errores);
            window.console.log(obj);
            //var vals = "Error Desconocido";
            //if( obj != null ) obj.forEach(function(k) { vals += Object.values(k) + "-\n\t"; });
            //vue.msg = vals;
            vue.activo = true;
            vue.$refs.alertarmod.invalido( "No se pudo registrar, no use caracteres estraño o puede que este nombre de modulo ya exista," );
          }

          // window.console.log(data);
        }).catch(error => {
          vue.$refs.alertarmod.invalido();
          this.activo = true;
          window.console.error(JSON.stringify(error));
          vue.msg = error;

          this.$notify(parseJsonError(error));
        });
    }
  },
  mounted(){

  }
};
</script>